import "./listSection.scss";

export const ListSection = ({ children }) => {
  return (
    <div className="list-section-container">
      <ul>{children}</ul>
    </div>
  );
};
